import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "fabb7484a43e47bd99822f5d0ea08768",
  title: "Italo",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-US",
  currency: "USD",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon-32x32.png"],
  logo: "/assets/images/logo.svg",
  domain: "experiences.italotreno.com",
  detectLocale: true,
  detectCurrency: true,
};
